export const baseFormRules = {
  // 账号名称
  name: [
    { required: true, message: '请输入账号名称', trigger: 'blur' }
  ],
  // 姓名
  realname: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  // 类型
  employment_type: [
    { required: true, message: '请选择人员性质', trigger: 'change' }
  ],
  office_location: [
    { required: true, message: '请选择办公地点', trigger: 'change' }
  ],
  // 手机号
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
  ],
  // 合同时间 - 验证开始日期
  contract_start_date: [
    { required: true, message: '请选择合同时间', trigger: 'change' }
  ]
}

export const privateFormRules = {
  id_number: [
    { required: true, message: '请输入身份证号码', trigger: 'blur' }
  ],
}



// WEBPACK FOOTER //
// ./src/views/audit-intern/audit-intern.rules.js